import { useState, useEffect, useRef } from 'react';
import { cloneDeep } from 'lodash-es';
import { TabList } from '@/pages/intelligence/pages/TopCharts/_config/topChartsConst';
import {
  echartsData,
  groupBy,
  moveZero,
  handleSerieSymbolConfig,
} from '@/pages/intelligence/utils/echartsUtils';
import { formatNum } from '@/pages/intelligence/utils/commonUtils';
import DataBrainIcon from '@/pages/intelligence/assets/svg/dataSource/databarin.svg';
import svgAppannie from '@/pages/intelligence/assets/svg/dataSource/appnnie.svg';
import svgSensortower from '@/pages/intelligence/assets/svg/dataSource/sensor-tower.svg';
import {
  ECHARTSCOLOR,
  LINE_COLORS,
  PREDICT_DATA_SVG_ICON,
} from '@/pages/intelligence/utils/echartsConst';
import {
  AnnieTiaoEchartImg,
  SensorTowerDianEchartImg,
  DatabrainHuiEchartImg,
} from '@/pages/intelligence/pages/TopCharts/_config/base64Img';
import ChartBubble, { TOP_CHARTS_TYPES } from '@/pages/intelligence/components/ChartBubble';
import { LINE_GRID_TOP } from '@/pages/intelligence/pages/TopCharts/_config/echarts';
import { DATA_SOURCE_NAME_MAP } from '@intelligence/pages/TopCharts/_config/topChartsConst';
import { ChartType } from '@intelligence/pages/TopCharts/_config/enums';

function usePredictedDataLegendInteraction(props: {
  chartsInstance: React.RefObject<any>;
  loading: boolean;
  chartType: ChartType;
  setLineOption: React.Dispatch<React.SetStateAction<any>>;
}) {
  const { chartsInstance, loading, chartType, setLineOption } = props;

  const [initialSeries, setInitialSeries] = useState<any[]>([]);

  const handleLegendSelectedChange = (params: any) => {
    const lineChartInstance = chartsInstance?.current?.getLineInstance();
    const seriesTmp = cloneDeep(initialSeries || []);
    const selected = params?.selected || {};
    const isPredictedDataShow =
      !Reflect.has(selected, 'Predicted Data') || Reflect.get(selected, 'Predicted Data');
    const lineOptionTmp = cloneDeep(lineChartInstance?.getOption() || {});

    if (isPredictedDataShow) {
      lineOptionTmp.series = seriesTmp;
    } else {
      lineOptionTmp.series = seriesTmp?.filter((serie: any) => {
        return !(serie?.name?.startsWith('Annie_') && serie?.IsPredictData);
      });
    }
    setLineOption(lineOptionTmp);
  };

  const bindEvents = () => {
    const lineChartInstance = chartsInstance?.current?.getLineInstance();
    lineChartInstance?.on('legendselectchanged', handleLegendSelectedChange);
  };

  const unbindEvents = () => {
    const lineChartInstance = chartsInstance?.current?.getLineInstance();
    lineChartInstance?.off('legendselectchanged', handleLegendSelectedChange);
  };

  useEffect(() => {
    if (loading) return;
    if (chartType !== ChartType.Line) return;
    bindEvents();

    return () => {
      unbindEvents();
    };
  }, [loading, chartType, initialSeries]);

  return {
    setInitialSeries,
  };
}

export default function useActiveUserLineCharts(props: any) {
  const {
    sendEchartsData,
    loading,
    dataSourceEachers,
    isShowRangeDayMonth = false,
    isMobileCompare = false,
    titleNow = '',
    topChartsType,
    imageType,
    chartType,
    dateType,
    startDate,
    endDate,
    chartsInstance,
    gameHighId = '',
    isStudio = false,
    followingRetentionLegend = false,
  } = props;

  // TOP_CHARTS_TYPES.COMPARE_MOBILE_ACTIVEREVDOWN All of time 数据需要排序避免显示错位
  const isCompareMobileActiveVerDown =
    topChartsType === TOP_CHARTS_TYPES.COMPARE_MOBILE_ACTIVEREVDOWN;

  // console.log('useActiveUserLineCharts', props);

  const dataSourceEachersOld = useRef({
    length: 0,
    data: [],
  });
  // 折线图的数据
  const [gameListSelect, setGameListSelect] = useState<any>({});
  const [lineOption, setLineOption] = useState<any>(null);
  const [Edates, setEdates] = useState(null);
  const [gameList, setGameList] = useState<any>([]);
  const [oanceIns, setOanceIns] = useState(0);
  const [lent, setLent] = useState<any>([]);

  const { setInitialSeries } = usePredictedDataLegendInteraction({
    chartsInstance,
    loading,
    chartType,
    setLineOption,
  });

  useEffect(() => {
    // console.log('useEffect2222-sendEchartsData');
    if (
      sendEchartsData !== undefined &&
      sendEchartsData !== null &&
      sendEchartsData?.length !== 0 &&
      // 修改判断方式，避免 all of time 数据量过大，导致 JSON.stringify 报错
      // JSON.stringify(sendEchartsData) !== '{}'
      Object.keys(sendEchartsData).length !== 0
    ) {
      // 线型图的数据修改
      lineEchartsList();
    }
  }, [sendEchartsData]);

  // 线型图的数据修改
  const lineEchartsList = () => {
    // 第一次进入的状态
    let abc_q = oanceIns;
    setOanceIns(++abc_q);
    // 赋值
    const lenten = sendEchartsData.timelineOfMetricChartlist || sendEchartsData.metricChartlist;
    // console.log('sendEchartsData', sendEchartsData);
    // console.log('lenten', lenten);
    // 获取线形图的
    const lent: any[] = [];
    // 展示的数据
    const showLentList: any[] = [];
    const sourceList = [];
    // 定义数组的个数
    lenten?.map((item: any, index: any) => {
      if (item?.metric_list) {
        item?.metric_list?.map(() => {
          if (index === 0) {
            lent?.push([]);
            showLentList?.push([]);
          }
        });
      } else {
        item?.metric_value_list?.map(() => {
          if (index === 0) {
            lent?.push([]);
            showLentList?.push([]);
          }
        });
      }
    });
    // 往定义好的数组里加值
    lenten?.map((item: any, index: any) => {
      if (item?.metric_list) {
        item?.metric_list?.map((citem: any, cindex: any) => {
          if (index === 0) {
            sourceList?.push(TabList[citem.source]);
          }
          lent[cindex]?.push({
            rank: item.rank_name,
            value: citem.value, // || 0,
            source: citem.source,
            cover: item.cover,
            time: item.time,
            b_predict: citem.b_predict || false,
          });
        });
      } else {
        item?.metric_value_list?.map((citem: any, cindex: any) => {
          if (index === 0) {
            sourceList?.push(TabList[citem.source]);
          }
          lent[cindex]?.push({
            rank: item.rank_name,
            value: citem.value, // || 0,
            source: citem.source,
            cover: item.cover,
            time: item.time,
            // metric: citem.metric, // TODO：可能要根据游戏是否是 appannie 来源来再判断是否有补齐数据
            b_predict: citem.b_predict || false,
          });
        });
      }
    });
    // console.log('lentlent', lent);
    // console.log('echartsData', echartsData(lent[0], 'value', isShowRangeDayMonth));
    setLent(lent);
    if (JSON.stringify(lent) !== '[]' && JSON.stringify(lent[0]) !== '[]') {
      setEdates(
        echartsData({
          echartsData: lent[0],
          cell: 'value',
          isShowRangeDayMonth,
          dateType,
          sortXAxis: isCompareMobileActiveVerDown,
        }).dataX,
      );
      dataSourceEachers.forEach((item: any, index: any) => {
        // 游戏名称列表
        const { dataL } = echartsData({
          echartsData: lent[index],
          cell: 'value',
          isShowRangeDayMonth,
          sortXAxis: isCompareMobileActiveVerDown,
        });
        echartsData({
          echartsData: lent[index],
          cell: 'value',
          isShowRangeDayMonth,
          sortXAxis: isCompareMobileActiveVerDown,
        })?.dataSerie?.forEach((citem: any, cindex: any) => {
          // 当前游戏下标
          const gameIndex = dataL.indexOf(citem.name);
          // 当前游戏下标对应相同色系颜色下标
          const gameColorIndex = gameIndex !== -1 ? gameIndex : cindex;
          showLentList[index]?.push(
            Object.assign(citem, {
              color:
                citem.IsPredictData && item.includes(DATA_SOURCE_NAME_MAP.appannie)
                  ? '#FBB545'
                  : dataSourceEachers?.length > 1
                  ? item.includes('DataBrain')
                    ? LINE_COLORS[2][gameColorIndex]
                    : item.includes(DATA_SOURCE_NAME_MAP.appannie)
                    ? LINE_COLORS[0][gameColorIndex]
                    : LINE_COLORS[1][gameColorIndex]
                  : ECHARTSCOLOR[gameColorIndex],
              name: `${
                item.includes('DataBrain')
                  ? 'DataBrain'
                  : item.includes(DATA_SOURCE_NAME_MAP.appannie)
                  ? 'Annie'
                  : 'Tower'
              }_${citem.name}`,
              icon: item.includes('DataBrain')
                ? DatabrainHuiEchartImg
                : item === 'App Annie'
                ? AnnieTiaoEchartImg
                : SensorTowerDianEchartImg,
              cover: citem.cover,
              source: item,
              lineStyle: {
                type: citem?.IsPredictData ? 'dashed' : 'solid',
              },
            }),
          );
        });
      });
    }
    setGameList(JSON.parse(JSON.stringify(showLentList)));
  };

  useEffect(() => {
    if (Edates && !loading) {
      handleEchartLine(); // 线性
    }
  }, [Edates, gameList, loading]);

  // 线性图
  const handleEchartLine = () => {
    let timeoption: any = {};
    const obj: any = {};
    const gameListWithoutPredictData: any[] = [];
    gameList.forEach((item: any) => {
      gameListWithoutPredictData?.push(item?.filter((item: any) => !item.IsPredictData));
    });
    const isPredict = JSON.parse(JSON.stringify(gameList))
      ?.flat(2)
      ?.some((item: any) => item?.IsPredictData == true);
    if (
      JSON.stringify(gameListSelect) === '{}' ||
      (dataSourceEachersOld.current?.length !== dataSourceEachers?.length &&
        dataSourceEachersOld.current?.length !== 0) ||
      (dataSourceEachers?.length === 1 &&
        dataSourceEachers[0] !== dataSourceEachersOld.current.data[0])
    ) {
      if (dataSourceEachers?.length === 1) {
        // 只有一个平台，取前六个
        gameListWithoutPredictData?.map((_, index) => {
          gameListWithoutPredictData[index]?.map((item: any, gIndex: any) => {
            // obj[item.name] = gIndex <= 5
            obj[item.name] = gIndex < 6;
          });
        });
      } else {
        // 多个平台
        gameListWithoutPredictData?.map((_, index) => {
          gameListWithoutPredictData[index]?.map((item: any, gIndex: any) => {
            // obj[item.name] = gIndex <= 2
            // obj[item.name] = gIndex < 2

            // if (item.source == 'App Annie') {
            //   // obj[item.name] = gIndex < (6 / (dataSourceEachers?.length || 1));
            //   obj[item.name] = gIndex < 6;
            // } else {
            //   obj[item.name] = false;
            // }

            if (isMobileCompare) {
              // mobile compare的折线图 默认选中前3个游戏的双平台（即6个图例）
              obj[item?.name] = gIndex <= 2;
            } else {
              // 其余保持原有默认逻辑，取 Annie的前6个游戏 作为默认选中的图例
              if (item.source === DATA_SOURCE_NAME_MAP.sensortower) {
                obj[item.name] = followingRetentionLegend ? true : gIndex < 6;
              } else {
                obj[item.name] = false;
              }
            }
          });
        });
      }
    } else {
      gameListWithoutPredictData?.map((_, index) => {
        gameListWithoutPredictData[index]?.map((item: any, _: any) => {
          obj[item.name] = gameListSelect[item.name];
          if (
            obj[item.name] === undefined &&
            followingRetentionLegend &&
            topChartsType === 'retention'
          ) {
            obj[item.name] = item.source === DATA_SOURCE_NAME_MAP.sensortower;
          }
        });
      });
      Object.keys(gameListSelect)?.map((item, _) => {
        if (!Object.keys(obj).includes(item))
          setGameListSelect(
            Object.assign(gameListSelect, {
              [item]: false,
            }),
          );
      });
    }
    const lineList = [];
    gameList?.map((_: any, index: any) => {
      gameList[index]?.map((citem: any, _: any) => {
        lineList?.push(citem);
      });
    });
    if (isPredict) {
      lineList?.push({
        name: 'Predicted Data',
        type: 'line',
      });
    }

    const getTrueName = (name: string) => {
      if (name.indexOf('DataBrain') >= 0) {
        return name?.replace('DataBrain_', '');
      }
      if (name.indexOf('Annie') >= 0) {
        return name?.replace('Annie_', '');
      }
      if (name.indexOf('Tower') >= 0) {
        return name?.replace('Tower_', '');
      }
    };

    // 按日期分组数据
    const lentByDay = groupBy(lent[0], (item: any) => item.time);
    // 当天是否有补齐数据
    // const dateIsPredict = lentByDay?.map(item => item.some((day: any) => day.b_predict));
    //   折线图悬浮窗函数
    const lineTooltip = (params: any) => {
      // console.log('paramsparamsparamsparams',params);
      // const paramsTemp = params?.map((item: any) => {
      //   return {
      //     ...item,
      //     seriesName: getTrueName(item.seriesName)
      //   }
      // });
      const validParams = params?.filter((item: any) => item.value !== '-'); // 去掉填充无效数据
      const orderParams = moveZero(validParams);
      const notPredictParams = orderParams.filter((item) => {
        const name = item.seriesName?.split('Annie_')[1];
        // 该游戏当天是否有补齐数据
        let isPredict = false;
        for (let i = 0; i < lentByDay[item.dataIndex]?.length; i++) {
          const day = lentByDay[item.dataIndex][i];
          if (day.rank === name) {
            isPredict = day.b_predict;
            break;
          }
        }
        // 有补齐数据且为补齐颜色
        // 没有补齐数据
        if ((isPredict && item.color === '#FBB545') || !isPredict) {
          return true;
        }
        return false;
      });

      return ChartBubble({
        data: notPredictParams,
        titleNow,
        topChartsType,
        imageType,
        chartType,
        startDate,
        endDate,
      });

      // let res = `<div style='font-size: 14px;overflow: hidden;padding: 5px 0;';><span style='float: left'>${params[0].name}</span>
      //   <span style='float: right;'>${titleNow}</span></div>`;
      // notPredictParams?.map((item) => {
      //   res += `<div style='font-size: 13px;overflow: hidden;text-align: left;'>
      //       <span>${item?.marker}</span>
      //       <span>${item.seriesName}</span>
      //       <span style='float: right;font-weight: 600;font-size: 12px;color: #000;margin-left: 40px'> ${item.value ? formatNum(Number(item.value)) : '-'}</span>
      //       </div>`
      // });

      // return res;
    };

    const getIsHigh = (parmas:any, str: string) => {
      const showObj = sendEchartsData?.metricChartlist?.find((v: any) => parmas?.replace(str, '') ==v?.name) || {};
      const showId = showObj?.gameId || '';
      // const showText = showObj?.name || '';
      return  gameHighId === showId && isStudio;
    };

    // console.log('gameListgameList',gameList)
    const _legend = gameList?.map((_: any, index: any) => {
      return {
        show: true,
        type: 'scroll',
        data: gameList[index]?.map((item: any) => {
          return {
            name: item.name,
            //   icon: item.icon,
            icon: 'circle',
            textStyle: {
              // color: item.color,
              color: '#888888',
            },
          };
        }),
        itemWidth: 8,
        itemHeight: 8,
        // 多行图例 每一行图例的bottom值 按照第一行到最后一行 从上到下 bottom值从大到小
        bottom: (gameList?.length - 1 - index) * 30 - 6,
        itemGap: 18,
        width: '100%',
        selected: obj,
        formatter: (parmas: any) => {
          if (parmas.indexOf('Predicted') >= 0) {
            return `{databrainImg|}${getIsHigh(parmas, '') ? '{boldB|' + parmas + '}' : '{a|' + parmas + '}'}`;
          }
          if (parmas.indexOf('DataBrain') >= 0) {
            const name = parmas.replace('DataBrain_', '');
            return `{databrainImg|}${getIsHigh(parmas, 'DataBrain_') ? '{boldB|' + name + '}' : '{a| ' + name + '}'}`;
          }
          if (parmas.indexOf('Annie') >= 0) {
            const name = parmas.replace('Annie_', '');
            return `{appannieImg|}${getIsHigh(parmas, 'Annie_') ? '{boldB|' + name + '}' : '{a| ' + name + '}'}`;
          }
          if (parmas.indexOf('Tower') >= 0) {
            const name = parmas.replace('Tower_', '');
            return `{sensortowerImg|}${getIsHigh(parmas, 'Tower_') ? '{boldB|' + name + '}' : '{a| ' + name + '}'}`;
          }
        },
        textStyle: {
          rich: {
            databrainImg: {
              height: 16,
              width: 16,
              backgroundColor: {
                image: DataBrainIcon,
              },
            },
            appannieImg: {
              height: 18,
              width: 18,
              backgroundColor: {
                image: svgAppannie,
              },
            },
            sensortowerImg: {
              height: 18,
              width: 18,
              backgroundColor: {
                image: svgSensortower,
              },
            },
            a: {
              color: '#888888',
              fontSize: 12,
            },
            boldB: {
              color: '#262832',
              fontSize: 12,
              fontWeight: 'bold',
            },
          },
        },
      };
    });
    if (isPredict) {
      _legend[0]?.data?.push({
        name: 'Predicted Data',
        // icon:dataBrainIcon,
        // icon: 'circle',
        icon: PREDICT_DATA_SVG_ICON,
        textStyle: {
          color: '#888888',
        },
        itemStyle: {
          color: '#FBB545',
        },
      });
      obj['Predicted Data'] = true;
    }

    timeoption = {
      grid: {
        // top: '8%',
        // bottom: '30%',
        // height: 250,
        // // left: '4%',
        // // right: '2%',
        // top: '10%',
        // bottom: '25%',
        // left: '55px',
        // right: '20px',
        // "top": "8%",
        top: LINE_GRID_TOP,
        bottom: dataSourceEachers?.length > 2 ? 102 : dataSourceEachers?.length > 1 ? 92 : 62,
        // "height": 200,
        left: '40px',
        right: '20px',
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          // 坐标轴指示器，坐标轴触发有效
          type: 'line', // 默认为直线，可选为：'line' | 'shadow'
        },
        padding: 0,
        formatter: lineTooltip, // Predicted DAU,
        textStyle: {},
        backgroundColor: 'rgba(0,0,0,0)'
      },
      legend: _legend,
      xAxis: {
        type: 'category',
        data: Edates,
        axisTick: { show: true, alignWithLabel: true },
        boundaryGap: true,
        axisLine: { show: true, lineStyle: { color: '#BFBFBF' } },
        axisLabel: {
          color: '#444444',
        },
      },
      yAxis: [
        {
          axisLabel: {
            fontSize: 12,
            formatter: (value: any, _: any) => {
              if (props.pageid === 'Revenue') {
                // if ((props.pageid === 'Revenue') && (value >= maxData)) {
                return `$${formatNum(value)}`;
              }
              return formatNum(value);
            },
            // color: '#BBBBBB',
            color: '#838697',
          },
          // max: function (value: any) {
          //   maxData = value.max;
          // },
          splitLine: {
            show: true,
            lineStyle: { color: '#E9E9E9', type: 'dashed' },
          },
          axisLine: { show: false },
          axisTick: { show: false },
          type: 'value',
        },
      ],
      series: lineList,
    };

    timeoption.series = handleSerieSymbolConfig(timeoption?.series);
    dataSourceEachersOld.current.length = dataSourceEachers?.length;
    dataSourceEachersOld.current.data = JSON.parse(JSON.stringify(dataSourceEachers));
    setLineOption(timeoption);
    setInitialSeries(Array.isArray(timeoption?.series) ? cloneDeep(timeoption.series) : []);
  };

  return {
    lineOption,
  };
}
